
export const RolesEnum = {
    Admin: 1,
    Manager: 2,
    Guide: 3,
};
